import { useDownloadFromS3 } from '@/hooks/queries/uploads/useUploadToS3'
import { AppCsvUploadType, CoreCsvUploadType, UploadScope } from '@repo/csv'
import { Button } from '@repo/ui/components'
import { FileDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type S3DownloadButtonProps = {
  uploadType: CoreCsvUploadType | AppCsvUploadType
  fileName: string
  scope: UploadScope
  label?: string
}

export function S3DownloadButton(props: S3DownloadButtonProps) {
  const { t } = useTranslation('common')

  const { handleDownload, isDownloading } = useDownloadFromS3(
    props.uploadType,
    props.fileName,
    props.scope,
  )

  return (
    <Button onClick={() => handleDownload()} disabled={isDownloading}>
      <FileDown className="size-4" />
      {props.label ?? t('s3DownloadButton')}
    </Button>
  )
}
